export const REQUEST = Symbol('Request provided by Universal');
export const RESPONSE = Symbol('Response provided by Universal');
